export const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://correcter-api.malitool.com';

export const API_ENDPOINTS = {
  AUTH: {
    LOGIN: `${API_BASE_URL}/api/auth/login`,
    REGISTER: `${API_BASE_URL}/api/auth/register`,
    PROFILE: `${API_BASE_URL}/api/auth/profile`,
    VERIFY_EMAIL: `${API_BASE_URL}/api/auth/verify-email`,
    RESEND_VERIFICATION: `${API_BASE_URL}/api/auth/resend-verification`,
    COINS: `${API_BASE_URL}/api/auth/coins`
  },
  UPLOAD: {
    IMPORT: `${API_BASE_URL}/api/upload/import`,
    NORMALIZE: `${API_BASE_URL}/api/upload/normalize`,
    STATUS: (queueId: string) => `${API_BASE_URL}/api/upload/normalize/${queueId}/status`,
    RETRY_NORMALIZE: `${API_BASE_URL}/api/upload/retry-normalize`
  },
  CUSTOMERS: {
    LIST: `${API_BASE_URL}/api/customers`,
    NORMALIZE_ADDRESS: `${API_BASE_URL}/api/customers/normalize-address`,
    UPDATE: (phone: string) => `${API_BASE_URL}/api/customers/${phone}`,
    DELETE: (phone: string) => `${API_BASE_URL}/api/customers/${phone}`,
  },
  ADMIN: {
    USERS: `${API_BASE_URL}/api/admin/users`,
    UPDATE_PASSWORD: `${API_BASE_URL}/api/admin/users/password`,
    UPDATE_COINS: `${API_BASE_URL}/api/admin/users/coins`
  },
  TRIAL: {
    NORMALIZE: `${API_BASE_URL}/api/trial/normalize`,
    REMAINING: `${API_BASE_URL}/api/trial/remaining`
  },
  PAYMENT: {
    PACKAGES: `${API_BASE_URL}/api/payment/packages`,
    UPGRADE: `${API_BASE_URL}/api/payment/upgrade`,
    QR_CODE: `${API_BASE_URL}/api/payment/qr-code`
  }
}; 